import { SuccessResult } from "./SuccessResult";

export const PlanDowngradeRequestSuccessResult: React.FC = () => {
  return (
    <SuccessResult
      title="Plan downgrade is successful"
      text="You will not be charged for this change. It will be reflected in your next billing cycle."
      hideConfetti
    />
  );
};
